import React from 'react';
import {
  Box,
  Dialog,
  Typography,
  DialogTitle,
  DialogActions,
  DialogContent,
  LinearProgress,
  DialogContentText,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const UploadingModal = ({ isUploading }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={isUploading}
      aria-labelledby="Uploading Modal">
      <DialogTitle align="center">{t('uploading_file')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography align="center">
            {t('uploading_file_in_process')}
          </Typography>
          <Typography align="center">{t('no_action_needs')}</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center', alignItems: 'center' }}>
        <Box width="100%" marginBottom="30px" maxWidth="500px">
          <LinearProgress color="primary" />
        </Box>
      </DialogActions>
    </Dialog>
  );
};

UploadingModal.propTypes = {
  isUploading: PropTypes.bool,
};

export default UploadingModal;
